import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

import { TypographyColor, TypographyFontSize } from '@design-system/components/atoms/typography/entities/typography.types';
import {
  FlightDurationFlightTime, FlightDurationSize
} from '@design-system/components/molecules/flight-duration/entities/flight-duration.types';
import { Icon, IconFillColor } from '@design-system/components/atoms/icon/entities/icon.types';
import { IconDsComponent } from '@design-system/components/atoms/icon/icon.component';
import { TypographyDsComponent } from '@design-system/components/atoms/typography/typography.component';
import { FlightScaleDsComponent } from '@design-system/components/atoms/flight-scale/flight-scale.component';

@Component({
  selector: 'app-ds-flight-duration',
  templateUrl: './flight-duration.component.html',
  styleUrls: ['./flight-duration.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    TypographyDsComponent,
    IconDsComponent,
    FlightScaleDsComponent,
  ]
})
export class FlightDurationDsComponent {

  @Input() size = FlightDurationSize.SM;
  @Input() flightTime: FlightDurationFlightTime;
  @Input() stops: number;
  @Input() stopsLabel: string;
  @Input() fare: string;
  @Input() planeModel: string;
  @Input() cabin: string;

  public readonly xxxsFontSize = TypographyFontSize.XXXS;
  public readonly minorFontSize = TypographyFontSize.Minor;

  public readonly primaryTextColor = TypographyColor.Primary;
  public readonly secondaryTextColor = TypographyColor.Secondary;

  public readonly iconDeparture = Icon.Departure;
  public readonly iconLocation = Icon.Location;

  public readonly iconColor = IconFillColor.Disabled;

  constructor() { }

  get isBigger(): boolean {
    return this.size === FlightDurationSize.LG || this.size === FlightDurationSize.MD;
  }

  get timeSize(): TypographyFontSize {
    return this.isBigger ? this.xxxsFontSize : this.minorFontSize;
  }

  get timeColor(): TypographyColor {
    return this.isBigger ? this.primaryTextColor : this.secondaryTextColor;
  }

}
